import { Component } from '@angular/core';

@Component({
  selector: 'payu',
  templateUrl: 'payu.html'
})
export class Payu {

  constructor() {
  }

}
// end file



// WEBPACK FOOTER //
// ./src/components/payment-methods/payu/payu.ts